import React, { useId } from 'react'
import { CURRENCIES } from '../../constants'
import SelectWithLoader from './SelectWithLoader'
import { HugeiconsIcon } from '@hugeicons/react'
import { ArrowDown01Icon } from '@hugeicons/core-free-icons'

const compactStyle = {
  container: (base) => ({
    ...base,
    height: '28px'
  }),
  menu: (base) => ({
    ...base
  }),
  control: (base, state) => ({
    ...base,
    width: '60px',
    borderRadius: '6px',
    backgroundColor: 'transparent',
    border: 'None',
    // react-select's own default control style adds this focus ring
    // independently of `border` - overriding border alone doesn't remove it.
    boxShadow: 'none',
    cursor: 'pointer',
    minHeight: '28px',
    height: '28px'
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: '13px'
  }),
  valueContainer: (base) => ({
    ...base,
    height: '28px',
    padding: '0 0 0 8px',
    // Grid (react-select's default) so the search input overlaps the value
    // instead of sitting beside it and pushing the label off-centre.
    display: 'grid',
    alignItems: 'center',
    justifyItems: 'center',
    fontSize: '13px'
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: '28px'
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: '4px',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: '4px',
  }),
  option: (provided) => ({
    ...provided,
    fontSize: '10px'
  }),
  singleValue: (provided) => ({
    ...provided,
    margin: 0,
    lineHeight: 1,
    fontSize: '10px'
  }),
}

const currencies = CURRENCIES.map(currency => ({
  value: currency,
  label: currency
}))

/**
 * Compact searchable currency-code picker (the "USD ⌄" pill). Used inside
 * CurrencyInput, and on its own where only the currency needs choosing.
 * `onChange` receives the selected `{ value, label }` option.
 */
const CurrencySelect = ({ currency, onChange, disabled = false, className = '', ...selectProps }) => {
  const selectId = useId()

  return (
    <SelectWithLoader
      isSearchable
      dropdownIndicator={<HugeiconsIcon icon={ArrowDown01Icon} size={10} />}
      styles={compactStyle}
      showIndicatorSeparator={false}
      defaultValue={currencies.find(curr => curr.value === 'USD')}
      id={selectId}
      className={['currency-input__select', className].filter(Boolean).join(' ')}
      options={currencies}
      value={currencies.find(curr => curr.value === currency)}
      disabled={disabled}
      onChange={onChange}
      aria-label='Currency'
      {...selectProps}
    />
  )
}

export default CurrencySelect
